'use strict';
module.exports = /^#!.*/;



//////////////////
// WEBPACK FOOTER
// ./~/shebang-regex/index.js
// module id = 442
// module chunks = 0